(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-your-size"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__findYourFitLoaded) return;
  window.__findYourFitLoaded = true;

  var FIT_PARAM = 'filter.p.m.custom.fit';
  var KINDS = ['dept', 'size', 'fit'];

  function clean(value) {
    return String(value == null ? '' : value).replace(/\s+/g, ' ').trim();
  }

  function setup(root) {
    if (!root || root.__fyfReady) return;

    var grid = root.querySelector('[data-fyf-grid]');
    var wrap = root.querySelector('[data-fyf-results-wrap]');
    var loadingEl = root.querySelector('[data-fyf-loading]');
    var emptyEl = root.querySelector('[data-fyf-empty]');
    var errorEl = root.querySelector('[data-fyf-error]');
    var statusEl = root.querySelector('[data-fyf-status]');
    var viewAll = root.querySelector('[data-fyf-viewall]');
    var appliedEl = root.querySelector('[data-fyf-applied]');
    var chipsEl = root.querySelector('[data-fyf-chips]');

    if (!grid || !wrap || !loadingEl || !emptyEl || !errorEl) return;

    root.__fyfReady = true;

    var sizeParam = clean(root.getAttribute('data-size-param')) || 'filter.v.option.size';
    var allUrl = clean(root.getAttribute('data-all-url')) || '/collections/all';
    var removeLabel = clean(root.getAttribute('data-remove-label')) || 'Remove filter';
    var limit = parseInt(root.getAttribute('data-limit'), 10);

    if (!(limit >= 1 && limit <= 4)) limit = 4;

    var controller = null;
    var token = 0;

    function checkedInput(kind) {
      return root.querySelector('input[data-fyf-input="' + kind + '"]:checked');
    }

    function inputValue(input) {
      return input ? clean(input.value) : '';
    }

    function setState(state, message) {
      loadingEl.hidden = state !== 'loading';
      emptyEl.hidden = state !== 'empty';
      errorEl.hidden = state !== 'error';
      grid.hidden = state === 'empty' || state === 'error';
      wrap.setAttribute('aria-busy', state === 'loading' ? 'true' : 'false');

      if (state === 'error') {
        errorEl.textContent = message || errorEl.getAttribute('data-default-text') || '';
      }

      if (statusEl) {
        if (state === 'loading') statusEl.textContent = loadingEl.textContent;
        else if (state === 'empty') statusEl.textContent = emptyEl.textContent;
        else if (state === 'error') statusEl.textContent = errorEl.textContent;
      }
    }

    function labelFor(input) {
      var label = input.labels && input.labels[0]
        ? input.labels[0]
        : root.querySelector('label[for="' + input.id + '"]');

      return clean(label ? label.textContent : input.value);
    }

    function renderChips(selection) {
      if (!appliedEl || !chipsEl) return;

      while (chipsEl.firstChild) chipsEl.removeChild(chipsEl.firstChild);

      var count = 0;

      KINDS.forEach(function (kind) {
        var input = selection[kind];

        if (!input || !inputValue(input)) return;

        count++;

        var text = labelFor(input);
        var li = document.createElement('li');
        var button = document.createElement('button');

        button.type = 'button';
        button.className = 'fyf__chip';
        button.setAttribute('data-fyf-remove', kind);
        button.setAttribute('aria-label', removeLabel + ': ' + text);

        var label = document.createElement('span');
        label.textContent = text;

        var x = document.createElement('span');
        x.className = 'fyf__chip-x';
        x.setAttribute('aria-hidden', 'true');
        x.textContent = '×';

        button.appendChild(label);
        button.appendChild(x);
        li.appendChild(button);
        chipsEl.appendChild(li);
      });

      appliedEl.hidden = count === 0;
    }

    function findProductGrid(doc) {
      return doc.querySelector('#ProductGridContainer ul#product-grid') ||
        doc.querySelector('ul#product-grid') ||
        doc.querySelector('ul.product-grid') ||
        doc.querySelector('.collection .product-grid') ||
        doc.querySelector('ul[id*="product-grid"]') ||
        doc.querySelector('[data-product-grid]') ||
        doc.querySelector('.product-grid');
    }

    /* ---------- Product card helpers ---------- */

    function textOf(el) {
      return el ? clean(el.textContent) : '';
    }

    function toNumber(str) {
      var n = parseFloat(String(str || '').replace(/[^0-9.]/g, ''));
      return isNaN(n) ? 0 : n;
    }

    function makeEl(tag, className, text) {
      var el = document.createElement(tag);
      if (className) el.className = className;
      if (text != null && text !== '') el.textContent = text;
      return el;
    }

    // Reads product data out of a theme card (Dawn-style markup, with fallbacks).
    function extractProduct(item) {
      var linkEl = item.querySelector('a[href*="/products/"]') || item.querySelector('a[href]');
      var imgEl = item.querySelector('.card__media img, .media img, img');

      var titleEl = item.querySelector('.card__heading a, .card__heading, h3 a, h3, h2 a, h2');

      var saleEl = item.querySelector('.price__sale .price-item--sale, .price-item--sale');
      var compareEl = item.querySelector('.price__sale s.price-item--regular, .price__sale .price-item--regular, s.price-item--regular, .price__compare .price-item');
      var regularEl = item.querySelector('.price__regular .price-item--regular, .price-item--regular');

      var onSale = !!(saleEl && compareEl && textOf(saleEl) && textOf(compareEl) && textOf(saleEl) !== textOf(compareEl));

      var current = onSale ? textOf(saleEl) : textOf(regularEl || saleEl);
      var compare = onSale ? textOf(compareEl) : '';

      var discount = 0;
      if (onSale) {
        var a = toNumber(compare);
        var b = toNumber(current);
        if (a > 0 && b > 0 && b < a) {
          discount = Math.round((1 - b / a) * 100);
          if (discount < 1 || discount > 99) discount = 0;
        }
      }

      // Theme badges: "Sale" / "Sold out" go to the bottom pill, anything else (e.g. "New") to the top label.
      var pill = '';
      var label = '';
      item.querySelectorAll('.badge, [class*="badge"]').forEach(function (b) {
        var t = textOf(b);
        if (!t) return;
        var low = t.toLowerCase();
        if (low === 'sale') { if (!pill) pill = 'Sale'; }
        else if (low === 'sold out') { pill = 'Sold out'; }
        else if (!label && !/%/.test(t)) { label = t; }
      });

      if (onSale && !pill) pill = 'Sale';

      return {
        href: linkEl ? linkEl.getAttribute('href') : '#',
        img: imgEl ? {
          src: imgEl.getAttribute('src') || '',
          srcset: imgEl.getAttribute('srcset') || '',
          sizes: imgEl.getAttribute('sizes') || '',
          alt: imgEl.getAttribute('alt') || ''
        } : null,
        title: textOf(titleEl) || (imgEl ? imgEl.getAttribute('alt') : ''),
        current: current,
        compare: compare,
        discount: discount,
        pill: pill,
        label: label
      };
    }

    function buildCard(data) {
      var li = makeEl('li', 'fyf__item');
      var a = makeEl('a', 'fyf-card');
      a.href = data.href;

      var media = makeEl('span', 'fyf-card__media');

      if (data.img && data.img.src) {
        var img = document.createElement('img');
        img.className = 'fyf-card__img';
        img.src = data.img.src;
        if (data.img.srcset) img.srcset = data.img.srcset;
        if (data.img.sizes) img.sizes = data.img.sizes;
        img.alt = data.img.alt || data.title || '';
        img.loading = 'lazy';
        media.appendChild(img);
      }

      if (data.discount > 0) {
        media.appendChild(makeEl('span', 'fyf-card__badge fyf-card__badge--top fyf-card__badge--discount', data.discount + '% off'));
      } else if (data.label) {
        media.appendChild(makeEl('span', 'fyf-card__badge fyf-card__badge--top fyf-card__badge--label', data.label));
      }

      if (data.pill) {
        media.appendChild(makeEl('span', 'fyf-card__badge fyf-card__badge--pill', data.pill));
      }

      var info = makeEl('span', 'fyf-card__info');
      info.appendChild(makeEl('span', 'fyf-card__title', data.title));

      if (data.current || data.compare) {
        var price = makeEl('span', 'fyf-card__price');

        if (data.compare) {
          price.appendChild(makeEl('s', 'fyf-card__price-compare', data.compare));
          price.appendChild(makeEl('span', 'fyf-card__price-sale', data.current));
        } else {
          price.appendChild(makeEl('span', 'fyf-card__price-regular', data.current));
        }

        info.appendChild(price);
      }

      a.appendChild(media);
      a.appendChild(info);
      li.appendChild(a);

      return li;
    }

    function render(html) {
      if (!html || html.indexOf('Liquid error') !== -1) {
        throw new Error('The collection page did not return usable HTML.');
      }

      var doc = new DOMParser().parseFromString(html, 'text/html');
      var sourceGrid = findProductGrid(doc);

      if (!sourceGrid) {
        throw new Error('Could not find the product.');
      }

      var sourceItems = Array.prototype.slice.call(sourceGrid.children).filter(function (node) {
        return node && node.nodeType === 1 && (
          node.matches('li.grid__item') ||
          node.matches('li') ||
          node.matches('[data-product-card], .product-card-wrapper')
        );
      });

      if (!sourceItems.length) {
        sourceItems = Array.prototype.slice.call(
          sourceGrid.querySelectorAll(':scope > li.grid__item, :scope > li, :scope > [data-product-card], :scope > .product-card-wrapper')
        );
      }

      while (grid.firstChild) grid.removeChild(grid.firstChild);

      sourceItems.slice(0, limit).forEach(function (item) {
        grid.appendChild(buildCard(extractProduct(item)));
      });

      if (!sourceItems.length) {
        setState('empty');
        return;
      }

      setState('ready');

      if (statusEl) {
        var count = Math.min(sourceItems.length, limit);
        statusEl.textContent = count + (count === 1 ? ' product found' : ' products found');
      }
    }

    function update() {
      var selection = {
        dept: checkedInput('dept'),
        size: checkedInput('size'),
        fit: checkedInput('fit')
      };

      var size = inputValue(selection.size);
      var fit = inputValue(selection.fit);

      renderChips(selection);

      var base = selection.dept ? selection.dept.getAttribute('data-url') : allUrl;

      if (!base) {
        setState('error', 'Choose a department collection in the section settings, or set the All products collection URL.');
        return;
      }

      var requestUrl;

      try {
        requestUrl = new URL(base, window.location.origin);
      } catch (e) {
        setState('error', 'The collection URL is invalid. Check the collection settings.');
        return;
      }

      if (size) requestUrl.searchParams.set(sizeParam, size);
      else requestUrl.searchParams.delete(sizeParam);

      if (fit) requestUrl.searchParams.set(FIT_PARAM, fit);
      else requestUrl.searchParams.delete(FIT_PARAM);

      if (viewAll) {
        viewAll.setAttribute('href', requestUrl.pathname + requestUrl.search + requestUrl.hash);
      }

      if (controller) controller.abort();

      controller = typeof AbortController === 'function' ? new AbortController() : null;
      var mine = ++token;

      setState('loading');

      fetch(requestUrl.toString(), {
        method: 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: {
          'Accept': 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        },
        signal: controller ? controller.signal : undefined
      })
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.text();
        })
        .then(function (html) {
          if (mine !== token) return;
          render(html);
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          if (mine !== token) return;

          setState('error', error && error.message ? error.message : 'Unable to load products.');
        });
    }

    function clearFilters(kinds) {
      kinds.forEach(function (kind) {
        root.querySelectorAll('input[data-fyf-input="' + kind + '"]').forEach(function (input) {
          input.checked = false;
        });
      });

      update();

      var focusTarget = root.querySelector(
        'input[data-fyf-input="' + kinds[0] + '"]:not(:disabled)'
      );

      if (focusTarget) focusTarget.focus();
    }

    root.addEventListener('change', function (event) {
      var target = event.target;

      if (target && target.matches && target.matches('input[data-fyf-input]')) {
        update();
      }
    });

    root.addEventListener('click', function (event) {
      var target = event.target && event.target.closest
        ? event.target.closest('[data-fyf-remove], [data-fyf-clear-all]')
        : null;

      if (!target || !root.contains(target)) return;

      if (target.hasAttribute('data-fyf-clear-all')) {
        clearFilters(KINDS);
      } else {
        clearFilters([target.getAttribute('data-fyf-remove')]);
      }
    });

    root.__fyfAbort = function () {
      token++;
      if (controller) controller.abort();
    };

    update();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-fyf]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector('[data-fyf]')
      : null;

    if (root && root.__fyfAbort) root.__fyfAbort();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
